var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page noScroll"},[_c('div',{staticClass:"page-content infinite-scroll noScroll"},[_c('Contact',{attrs:{"isPrivacy":true,"prevData":_vm.contactItem},on:{"on-save":_vm.save,"reload":_vm.reload}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }